export const PREAMBLE_INPUTS_ALL_TYPE_REQUEST = 'PREAMBLE_INPUTS_ALL_TYPE_REQUEST';
export const PREAMBLE_INPUTS_ALL_TYPE_SUCCESS = 'PREAMBLE_INPUTS_ALL_TYPE_SUCCESS';
export const PREAMBLE_INPUTS_ALL_TYPE_FAIL = 'PREAMBLE_INPUTS_ALL_TYPE_FAIL';

